
import Footer from "./components/Footer";
import Nav from "./components/Nav";


import Main from "./Main"


function App() {
  

  return (
    <div className="App">
      
      <Nav/>
        <Main/>
      <Footer/>
    </div>
  );
}

export default App;
